/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Who_Fc_1Inputs */

const en_fc_vs_who_fc_1 = /** @type {(inputs: Fc_Vs_Who_Fc_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`are a student, hobbyist or YouTuber who wants pro tools without a subscription`)
};

/**
* | output |
* | --- |
* | "are a student, hobbyist or YouTuber who wants pro tools without a subscription" |
*
* @param {Fc_Vs_Who_Fc_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_who_fc_1 = /** @type {((inputs?: Fc_Vs_Who_Fc_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Who_Fc_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_who_fc_1(inputs)
});
export { fc_vs_who_fc_1 as "fc.vs.who.fc.1" }